import { Box, Stack, Typography } from "@mui/material";

export const columns = [
  // {
  //   accessorKey: "Components",
  //   header: "Material Code",
  //   size: 120,
  //   enableSorting: false,
  //   // muiTableHeadCellProps: { align: "center" },
  // },
  {
    accessorKey: "Cost Code ",
    header: "Cost Code",
    size: 100,
    enableHiding: false,
    enableSorting: false,
  },
  {
    accessorKey: "Description",
    header: "Material Description",
    size: 290,
    enableHiding: false,
    enableSorting: false,
    // muiTableHeadCellProps: { align: "center" },
  },
  // {
  //     accessorKey: "BOM Adder",
  //     header: "BOM Adder",
  //     size: 200,
  //     enableSorting: false,
  // muiTableHeadCellProps: { align: "center" },
  // },
  // {
  //   accessorKey: "Total Weight (Kg)", //!!This is the value from estimation. Needs to be renamed to esimated weight.!
  //   header: "Total Weight",
  //   Header: (
  //     <div>
  //       <div>Total</div>
  //       <div>Weight </div>
  //       <div>(kg)</div>
  //     </div>
  //   ),
  //   size: 80,
  //   enableSorting: false,
  //   muiTableBodyCellProps: { align: "right" },
  //   muiTableHeadCellProps: { align: "left" },
  // },
  // {
  //   accessorKey: "Total Weight (Kg)", //actual weight from est
  //   header: "Total Weight (Kg)",
  //   Header: (
  //     <div>
  //       <div>Actual</div>
  //       <div>Weight </div>
  //       <div>(kg)</div>
  //     </div>
  //   ),
  //   size: 80,
  //   enableSorting: false,
  //   muiTableBodyCellProps: { align: "right" },
  //   muiTableHeadCellProps: { align: "left" },
  // },
  // {
  //     accessorKey: "Qty",
  //     header: "Qty",
  //      size: 80,
  //     enableSorting: false,
  // muiTableHeadCellProps: { align: "center" },
  // },
  // {
  //     accessorKey: "Unit",
  //     header: "Unit",
  //     size: 70,
  //     enableSorting: false,
  // muiTableHeadCellProps: { align: "center" },
  // },
  // {
  //     accessorKey: "Unit Cost",
  //     header: "Unit Cost",
  //     size: 70,
  //     enableSorting: false,
  // muiTableHeadCellProps: { align: "center" },
  // },
  // {
  //     accessorKey: "Total Cost",
  //     header: "Total Cost",
  //     enableSorting: false,
  // muiTableHeadCellProps: { align: "center" },
  //     size: "50",
  // },
  {
    accessorKey: "Cost (US $)",
    header: "Est. Material Cost $",
    Header: (
      <div>
        <div>Estimated</div>
        <div>Material Cost</div>
        <div>($)</div>
      </div>
    ),
    size: 90,
    enableSorting: false,
    muiTableBodyCellProps: { align: "right" },
    // muiTableHeadCellProps: { align: "center" },
    Footer: () => (
      <Stack>
        <Box color="warning.main" sx={{ textAlign: "center" }}>
          {/* {getValues("totalMaterialCost") || 0} */}
        </Box>
      </Stack>
    ),
  },
  {
    accessorKey: "actual_cost",
    header: "Actual Material Cost $",
    Header: (
      <div>
        <div>Actual</div>
        <div>Material Cost</div>
        <div>($)</div>
      </div>
    ),
    size: 90,
    enableSorting: false,
    muiTableBodyCellProps: { align: "right" },
    Cell: ({ cell }) => (
      <>
        {cell.getValue() ? (
          Math.round(cell.getValue()) ? (
            <Typography color={"green"}>
              {Math.round(cell.getValue())}
            </Typography>
          ) : (
            <Typography color={"red"}>Not bought yet</Typography>
          )
        ) : (
          <Typography color={"red"}>Not bought yet</Typography>
        )}
      </>
    ),
    // muiTableHeadCellProps: { align: "center" },
    Footer: () => (
      <Stack>
        <Box color="warning.main" sx={{ textAlign: "center" }}>
          {/* {getValues("totalMaterialCost") || 0} */}
        </Box>
      </Stack>
    ),
  },
  // {
  //   accessorKey: "Total Manhour",
  //   header: "Total Manhour",
  //   muiTableBodyCellProps: { align: "right" },
  //   // muiTableHeadCellProps: { align: "center" },
  //   Header: (
  //     <div>
  //       <div>Est.</div>
  //       <div>FAB Hours</div>
  //       {/* <div>Hours</div> */}
  //     </div>
  //   ),
  //   Cell: ({ cell }) => (
  //     <>{cell.getValue() ? Math.round(cell.getValue()) : ""}</>
  //   ),
  //   size: 80,
  //   enableSorting: false,
  // },
  // {
  //   accessorKey: "actual_hours",
  //   header: "Actual FAB Hrs",
  //   Header: (
  //     <div>
  //       <div>Actual</div>
  //       <div>FAB Hours</div>
  //       {/* <div>Hours</div> */}
  //     </div>
  //   ),
  //   size: 90,
  //   enableSorting: false,
  //   muiTableBodyCellProps: { align: "right" },
  //   Cell: ({ cell }) => (
  //     <>{cell.getValue() ? Math.round(cell.getValue()) : ""}</>
  //   ),
  //   // muiTableHeadCellProps: { align: "center" },
  //   // Cell: ({ cell }) => (<>{cell.getValue()?.split(".")[0]}</>),
  //   Footer: () => (
  //     <Stack>
  //       <Box color="warning.main" sx={{ textAlign: "center" }}>
  //         {/* {getValues("totalHours") || 0} */}
  //       </Box>
  //     </Stack>
  //   ),
  // },
  {
    accessorKey: "Remarks",
    header: "Remarks",
    enableSorting: false,
    // muiTableHeadCellProps: { align: "center" },
    size: 100,
  },
  // ...othercolumns
];

export const columns2 = () => [
  // {
  //   accessorKey: "Components",
  //   header: "Material Code",
  //   size: 120,
  //   enableSorting: false,
  //   // muiTableHeadCellProps: { align: "center" },
  // },
  {
    accessorKey: "Cost Code ",
    header: "Cost Code",
    size: 100,
    enableHiding: false,
    enableSorting: false,
  },
  {
    accessorKey: "Description",
    header: "Material Description",
    size: 200,
    enableHiding: false,
    enableSorting: false,
    // muiTableHeadCellProps: { align: "center" },
  },
  {
    accessorKey: "Qty",
    header: "Quantity",
    Header: (
      <div>
        <div>Quantity</div>
      </div>
    ),
    size: 50,
    enableSorting: false,
    muiTableBodyCellProps: { align: "right" },
    Cell: ({ cell }) => {
      return Math.round(cell.getValue());
    },
    // Summary for grouped rows
    AggregatedCell: ({ row }) => {
      const total = row.subRows.reduce(
        (acc, curr) => acc + (Number(curr.original["Qty"]) || 0),
        0
      );
      return (
        <Typography color="primary" fontWeight="bold">
          {total}
        </Typography>
      );
    },
  },
  {
    accessorKey: "Cost (US $)",
    header: "Est. Material Cost $",
    Header: (
      <div>
        <div>Estimated</div>
        <div>Material Cost</div>
        <div>($)</div>
      </div>
    ),
    size: 90,
    enableSorting: false,
    muiTableBodyCellProps: { align: "right" },
    Cell: ({ cell }) => {
      return Math.round(cell.getValue());
    },
    // Summary for grouped rows
    AggregatedCell: ({ row }) => {
      const total = row.subRows.reduce(
        (acc, curr) => acc + (Number(curr.original["Cost (US $)"]) || 0),
        0
      );
      return (
        <Typography color="primary" fontWeight="bold">
          Total: ${Math.round(total)}
        </Typography>
      );
    },
  },
  {
    accessorKey: "actual_cost",
    header: "Actual Material Cost $",
    Header: (
      <div>
        <div>Actual</div>
        <div>Material Cost</div>
        <div>($)</div>
      </div>
    ),
    size: 90,
    enableSorting: false,
    muiTableBodyCellProps: { align: "right" },
    Cell: ({ cell }) => (
      <>
        {cell.getValue() ? (
          Math.round(cell.getValue()) ? (
            <Typography color={"green"}>
              {Math.round(cell.getValue())}
            </Typography>
          ) : (
            <Typography color={"red"}>Not bought yet</Typography>
          )
        ) : (
          <Typography color={"red"}>Not bought yet</Typography>
        )}
      </>
    ),
    AggregatedCell: ({ row }) => {
      const total = row.subRows.reduce(
        (acc, curr) => acc + (Number(curr.original["actual_cost"]) || 0),
        0
      );
      return (
        <Typography color="primary" fontWeight="bold">
          Total: ${Math.round(total)}
        </Typography>
      );
    },
    // muiTableHeadCellProps: { align: "center" },
    Footer: () => (
      <Stack>
        <Box color="warning.main" sx={{ textAlign: "center" }}>
          {/* {getValues("totalMaterialCost") || 0} */}
        </Box>
      </Stack>
    ),
  },
  // {
  //   accessorKey: "Est.FAB HoursHours",
  //   header: "Est.FAB HoursHours",
  //   Header: (
  //     <div>
  //       <div>Est.</div>
  //       <div>FAB Hours</div>
  //       <div>Hours</div>
  //     </div>
  //   ),
  //   size: 90,
  //   enableSorting: false,
  //   muiTableBodyCellProps: { align: "right" },
  //   Cell: ({ cell }) => <></>,
  //   AggregatedCell: ({ row }) => {
  //     const total = fabData[row.original["Cost Code "]]?.totalManHours || 0;
  //     return (
  //       <Typography color="primary" fontWeight="bold">
  //         {total || 0}
  //       </Typography>
  //     );
  //   },
  //   // muiTableHeadCellProps: { align: "center" },
  //   Footer: () => (
  //     <Stack>
  //       <Box color="warning.main" sx={{ textAlign: "center" }}>
  //         {/* {getValues("totalMaterialCost") || 0} */}
  //       </Box>
  //     </Stack>
  //   ),
  // },
  // {
  //   accessorKey: "Actual FAB HoursHours",
  //   header: "Actual FAB HoursHours",
  //   Header: (
  //     <div>
  //       <div>Actual</div>
  //       <div>FAB Hours</div>
  //       <div>Hours</div>
  //     </div>
  //   ),
  //   size: 90,
  //   enableSorting: false,
  //   muiTableBodyCellProps: { align: "right" },
  //   Cell: ({ cell }) => <></>,
  //   AggregatedCell: ({ row }) => {
  //     const total = fabData[row.original["Cost Code "]]?.actual_cost || 0;
  //     return (
  //       <Typography color="primary" fontWeight="bold">
  //         {total || 0}
  //       </Typography>
  //     );
  //   },
  //   // muiTableHeadCellProps: { align: "center" },
  //   Footer: () => (
  //     <Stack>
  //       <Box color="warning.main" sx={{ textAlign: "center" }}>
  //         {/* {getValues("totalMaterialCost") || 0} */}
  //       </Box>
  //     </Stack>
  //   ),
  // },
  // {
  //   accessorKey: "Weight (lb)",
  //   header: "Weight (lb)",
  //   Header: (
  //     <div>
  //       <div>Weight</div>
  //       <div>(lb)</div>
  //       {/* <div>Hours</div> */}
  //     </div>
  //   ),
  //   size: 90,
  //   enableSorting: false,
  //   muiTableBodyCellProps: { align: "right" },
  //   Cell: ({ cell }) => <>{cell.getValue()}</>,
  //   AggregatedCell: ({ row }) => {
  //     const total = row.subRows.reduce(
  //       (acc, curr) => acc + (Number(curr.original["Weight (lb)"]) || 0),
  //       0
  //     );
  //     return (
  //       <Typography color="primary" fontWeight="bold">
  //         Total: {Math.round(total)}
  //       </Typography>
  //     );
  //   },
  //   // muiTableHeadCellProps: { align: "center" },
  //   Footer: () => (
  //     <Stack>
  //       <Box color="warning.main" sx={{ textAlign: "center" }}>
  //         {/* {getValues("totalMaterialCost") || 0} */}
  //       </Box>
  //     </Stack>
  //   ),
  // },
  {
    accessorKey: "Remarks",
    header: "Remarks",
    enableSorting: false,
    // muiTableHeadCellProps: { align: "center" },
    size: 100,
  },
  // ...othercolumns
];
